/*
 *  被封禁弹窗
 */
import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import banned from '@/assets/img/banned.png';
import ReportModal from '../report';
import globalStore from '@/store/global';
import Conf from '@/common/conf';

const Ban = observer(props => {
  const { onClose, onSucc } = props;

  return (
    <div className="flex flex-col items-center w-378px pt-8px">
      <img src={banned} className="size-56px" alt="" />
      <div className="text-18px leading-25px text-primary font-bold my-16px">
        封禁提醒
      </div>
      <div className="text-14px leading-17px text-primary-opacity text-opacity-80">
        您因为违反{Conf.appName}用户协议，已被封禁
      </div>
      <div className="text-12px leading-22px mt-8px mb-24px">
        <span className="text-primary-opacity text-opacity-50">如有疑问请点击 </span>
        <span
          onClick={evt => {
            ReportModal.show({
              mask: false,
            });
          }}
          className="text-[#0E6CF2] cursor-pointer"
        >
          此处进行申诉
        </span>
      </div>
      <div
        onClick={evt => {
          onClose();
          globalStore.gotoHome();
        }}
        style={{
          background: '#000',
        }}
        className="vh-center w-92px h-40px text-14px rounded-12px text-white font-bold cursor-pointer"
      >
        确认
      </div>
    </div>
  );
});

export default Ban;
